import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppActions } from './actions';
import { State } from './state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private metaService: Meta,
    private readonly store: Store<State>) {
    this.router.events.pipe(filter(e => e instanceof ActivationEnd)).subscribe(() => {
      const childRoute = this.getChild(this.activatedRoute);
      if (childRoute?.snapshot?.data?.meta) {
        this.metaService.addTag(childRoute?.snapshot?.data['meta']);
      }
    });
  }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const sourceId = params.get('source');
      if (sourceId) {
        this.store.dispatch(AppActions.applicantSourceSet({ id: +sourceId }));
      }
    });
  }

  getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
